import {
  WALLET_CLEAR_FILTERS,
  WALLET_LIST_FETCHING,
  WALLET_LIST_SUCCESS,
  WALLET_RECEIVE_FILTERS
} from './types'
import { getWallets } from '../../../integration/resources/wallet/requests'

export const walletListFetching = () => ({
  type: WALLET_LIST_FETCHING
})

export const walletListSuccess = (payload) => ({
  type: WALLET_LIST_SUCCESS,
  payload
})

export const walletReceiveFilters = (payload) => ({
  type: WALLET_RECEIVE_FILTERS,
  payload
})

export const walletClearFilters = () => ({
  type: WALLET_CLEAR_FILTERS
})

export const getAllWallets = (increment = false) => {
  return async (dispatch, getState) => {
    dispatch(walletListFetching())

    const { filters } = getState().walletReducer

    let { page } = filters

    if (increment) {
      page += 1
    }

    const params = {
      ...filters,
      page
    }

    const {
      data,
      metadata: { pagination }
    } = await getWallets({ params })

    dispatch(
      walletListSuccess({
        data,
        pagination,
        increment
      })
    )
  }
}

export const walletApplyFilters = (filters) => [
  walletReceiveFilters(filters),
  getAllWallets()
]

export const walletClearAllFilter = () => [
  walletClearFilters(),
  getAllWallets()
]
